// 한국어 라벨링 함수들

export const getKoreanLabel = (option: string): string => {
  const labelMap: { [key: string]: string } = {
    // 헤어 스타일
    'NoHair': '대머리',
    'Eyepatch': '안대',
    'Hat': '모자',
    'WinterHat1': '겨울모자1',
    'WinterHat2': '겨울모자2',
    'WinterHat3': '겨울모자3', 
    'WinterHat4': '겨울모자4',
    'LongHairBigHair': '롱헤어(볼륨)',
    'LongHairBob': '롱헤어(밥)',
    'LongHairBun': '롱헤어(번)',
    'LongHairCurly': '롱헤어(컬리)',
    'LongHairCurvy': '롱헤어(웨이브)',
    'LongHairDreads': '롱헤어(드레드)',
    'LongHairFrida': '롱헤어(프리다)',
    'LongHairFro': '롱헤어(아프로)',
    'LongHairFroBand': '롱헤어(아프로+밴드)',
    'LongHairNotTooLong': '롱헤어(미디움)',
    'LongHairShavedSides': '롱헤어(옆면삭발)',
    'LongHairMiaWallace': '롱헤어(미아)',
    'LongHairStraight': '롱헤어(스트레이트)',
    'LongHairStraight2': '롱헤어(스트레이트2)',
    'LongHairStraightStrand': '롱헤어(스트레이트 가닥)',
    'ShortHairDreads01': '숏헤어(드레드1)',
    'ShortHairDreads02': '숏헤어(드레드2)',
    'ShortHairFrizzle': '숏헤어(곱슬)',
    'ShortHairShaggyMullet': '숏헤어(샤기멀렛)',
    'ShortHairShortCurly': '숏헤어(컬리)',
    'ShortHairShortFlat': '숏헤어(플랫)',
    'ShortHairShortRound': '숏헤어(라운드)',
    'ShortHairShortWaved': '숏헤어(웨이브)',
    'ShortHairSides': '숏헤어(옆면)',
    'ShortHairTheCaesar': '숏헤어(시저)',

    // 액세서리
    'Blank': '없음',
    'Kurt': '쿠르트',
    'Prescription01': '안경1',
    'Prescription02': '안경2',
    'Round': '원형안경',
    'Sunglasses': '선글라스',
    'Wayfarers': '웨이파러',

    // 눈
    'Close': '감은 눈',
    'Cry': '우는 눈',
    'Default': '기본',
    'Dizzy': '어지러운',
    'EyeRoll': '눈 굴리기',
    'Happy': '행복한',
    'Hearts': '하트',
    'Side': '옆보기',
    'Squint': '찡그린',
    'Surprised': '놀란',
    'Wink': '윙크',
    'WinkWacky': '장난스런 윙크',

    // 눈썹
    'Angry': '화난',
    'AngryNatural': '자연스럽게 화난',
    'DefaultNatural': '자연스러운 기본',
    'FlatNatural': '자연스럽게 평평한',
    'RaisedExcited': '흥분한',
    'RaisedExcitedNatural': '자연스럽게 흥분한',
    'SadConcerned': '슬픈',
    'SadConcernedNatural': '자연스럽게 슬픈',
    'UnibrowNatural': '자연스러운 일자눈썹',
    'UpDown': '위아래',
    'UpDownNatural': '자연스러운 위아래',

    // 입
    'Concerned': '걱정스러운',
    'Disbelief': '믿기지 않는',
    'Eating': '먹는',
    'Grimace': '찡그린',
    'Sad': '슬픈',
    'ScreamOpen': '비명지르는',
    'Serious': '진지한',
    'Smile': '웃는',
    'Tongue': '혀내민',
    'Twinkle': '반짝이는',
    'Vomit': '토하는',

    // 공통 색상들 (헤어, 피부, 의상에 공통 사용)
    'Auburn': '적갈색',
    'Black': '검은색',
    'Blonde': '금발',
    'BlondeGolden': '황금 금발',
    'Brown': '갈색',
    'BrownDark': '진한 갈색',
    'PastelPink': '파스텔 핑크',
    'Platinum': '플래티넘',
    'Red': '빨간색',
    'SilverGray': '은회색',
    'Blue01': '파란색1',
    'Blue02': '파란색2',
    'Blue03': '파란색3',
    'Gray01': '회색1',
    'Gray02': '회색2',
    'Heather': '헤더',
    'PastelBlue': '파스텔 블루',
    'PastelGreen': '파스텔 그린',
    'PastelOrange': '파스텔 오렌지',
    'PastelRed': '파스텔 레드',
    'PastelYellow': '파스텔 옐로우',
    'Pink': '핑크',
    'White': '흰색',
    'Tanned': '선탠',
    'Yellow': '노란색',
    'Pale': '창백한',
    'Light': '밝은',
    'DarkBrown': '진한 갈색'
  };

  return labelMap[option] || option;
};
